import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNl = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 17 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_9162_14662",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 17,
		height: 17,
		children: /* @__PURE__ */ _jsx("circle", {
			cx: 8.5,
			cy: 8.5,
			r: 8.5,
			fill: "#D9D9D9"
		})
	}), /* @__PURE__ */ _jsxs("g", {
		mask: "url(#mask0_9162_14662)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M-4 5.66668H22V11.3333H-4V5.66668Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M-4 0H22V5.66668H-4L-4 0Z",
				fill: "#CD1F2A"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M-4 11.3333H22V17H-4V11.3333Z",
				fill: "#1D4185"
			})
		]
	})]
});
export default SvgNl;
